import QuestionResult from '@/models/question_result'
import Vue from 'vue'
import Vuex from 'vuex'
import Question from '../models/question'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    type: 0,
    data: [] as Question[],
  },

  mutations: {
    setType(state, type: number) {
      state.type = type
    },
    setQuestions(state, questions: Question[]) {
      state.data = questions
    },
  }

})

export default store